export Download from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_download.svg';
export Plus from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_plus.svg';
export Warning from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_warning.svg';
export Tick from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_tick.svg';
export Edit from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_edit.svg';
export Cross from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_cross.svg';
export Search from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_search.svg';
export StudentManagement from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_student-management.svg';
export Empty from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_empty.svg';
export PrintSignIn from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_print-signin.svg';
export SolidRight from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_right_solid.svg';
export SolidLeft from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_left_solid.svg';
export Profile from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_profile.svg';
export Upload from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_upload.svg';
export View from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_view.svg';
export Forward from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_forward.svg';
export Guide from '@3plearning/3p-teacheradmin-assets/assets/icons/icon_guide.svg';
export Warning2 from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_warning.svg';
export Sent from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_sent.svg';
export Unsent from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_unsent.svg';
export EmailInvalid from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_email_invalid.svg';
export EmailSent from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_email_sent.svg';
export EmailValid from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_email_valid.svg';
export EmailVerified from '@3plearning/3p-teacheradmin-assets/assets/icons/ico_email_verified.svg';



// WEBPACK FOOTER //
// ./app/helpers/icon-dictionary.js